import { Box, useTheme } from '@mui/material';
import { Small } from 'components/Typography';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const FilterButtons = ({
  menuItems = ['전체'],
  selectedFilter,
  onFilterChange,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 2, pb: 2, ...props.sx }}>
      <Swiper
        modules={[FreeMode]}
        freeMode={{
          enabled: true,
          momentum: true,
          momentumRatio: 0.8,
          momentumVelocityRatio: 0.8,
        }}
        slidesPerView="auto"
        spaceBetween={8}
        speed={400}
        slideToClickedSlide={true}
        style={{ paddingBottom: '8px' }}
      >
        {menuItems.map((filter, index) => (
          <SwiperSlide key={index} style={{ width: 'auto' }}>
            <Box
              sx={{
                padding: '4px 12px 6px 12px',
                borderRadius: '20px',
                backgroundColor:
                  selectedFilter === filter
                    ? theme.palette.primary.mainBlue
                    : theme.palette.primary.grey10,
                fontSize: '14px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={() => onFilterChange(filter)}
            >
              <Small
                sx={{
                  color:
                    selectedFilter === filter
                      ? theme.palette.primary.white
                      : theme.palette.primary.greytxt,
                }}
              >
                {filter}
              </Small>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default FilterButtons;
